export const GET_OVERRIDE_CONFIG_SUCCESS_CONFIG_PROPERTIES =
    'europa.config.GetOverrideConfig.ConfigProperties';
export const GET_OVERRIDE_CONFIG_FAILURE_UNEXPECTED_FAILURE =
    'europa.config.GetOverrideConfig.UnexpectedFailure';
export const GET_PUBLIC_CONFIG_SUCCESS_CLIENT_CONFIG_RESULT =
    'europa.config.GetPublicConfig.ClientConfigResult';
export const GET_PUBLIC_CONFIG_FAILURE_UNEXPECTED_FAILURE =
    'europa.config.GetPublicConfig.UnexpectedFailure';
export const SET_OVERRIDE_CONFIG_FAILURE_CONFIG_FAILURE =
    'europa.config.SetOverrideConfig.ConfigFailure';
export const SET_OVERRIDE_CONFIG_FAILURE_OPERATION_NOT_PERMITTED =
    'europa.config.SetOverrideConfig.OperationNotPermitted';
export const SET_OVERRIDE_CONFIG_SUCCESS_PROPERTIES_SET =
    'europa.config.SetOverrideConfig.PropertiesSet';
export const SET_OVERRIDE_CONFIG_FAILURE_UNEXPECTED_FAILURE =
    'europa.config.SetOverrideConfig.UnexpectedFailure';
